import http from '@/extensions/http/index.js'
import { api_error, ENDPOINTS } from '@/helpers/index.js'

export const riddle = {
  state: {
    all: null,
    count: 0,
    current: 1,
    ordered_map: [],
  },
  mutations: {
    updateOrderedMap(state) {
      state.ordered_map = Object.values(state.all)
        .toSorted((riddleA, riddleB) => riddleA.order - riddleB.order)
        .map(({ id }) => id)
    },
    setRiddles(state, riddles) {
      state.all = riddles
    },
    updateCurrentRiddle(state, completed_riddles_count) {
      state.current = state.ordered_map[completed_riddles_count]?.toString() ?? null
    },
    updateRiddleCount(state) {
      state.count = Object.values(state.all).length
    },
  },
  actions: {
    async initRiddles(context) {
      try {
        const { data } = await http.$get(ENDPOINTS.RIDDLE.INDEX)
        context.commit('setRiddles', data)
        context.commit('updateRiddleCount')
        context.commit('updateOrderedMap')
        await context.dispatch('updateCurrentRiddle')
      } catch ({ response }) {
        if (response) return api_error(response)
      }
    },
    async resetRiddles(context) {
      try {
        await context.dispatch('updateAppStatus')
        await context.dispatch('initRiddles')
        await context.dispatch('updateAppStatus', true)
      } catch ({ response }) {
        if (response) return api_error(response)
      }
    },
    updateCurrentRiddle(context) {
      context.commit('updateCurrentRiddle', context.rootState.hunter.completed_riddles_count)
    },
  },
}
